export class DecisionMaking 
{
    public DecisionId : Number;
    public DecisionName : string;
    public IsActive : boolean;
}